import React from "react";
import ModalFormEmpresa from "./ModalFormEmpresa";

const ModalEmpresa = ({ show, handleClose, empresa }) => {
  return (
    <ModalFormEmpresa show={show} handleClose={handleClose} empresa={empresa} />
  );
};

export default ModalEmpresa;
